import type { Glyph } from "./types";

export const CheckCircleIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M45.291 25.001C45.291 13.795 36.206 4.711 25.001 4.711C13.795 4.711 4.711 13.795 4.711 25.001C4.711 36.206 13.795 45.291 25.001 45.291C36.206 45.291 45.291 36.206 45.291 25.001ZM47.091 25.001C47.09 37.2 37.2 47.09 25.001 47.091C12.801 47.091 2.91 37.201 2.91 25.001C2.91 12.801 12.801 2.91 25.001 2.91C37.201 2.91 47.091 12.801 47.091 25.001Z" />
    <path d="M34.254 19.413C34.605 19.062 35.175 19.062 35.526 19.413C35.878 19.765 35.878 20.335 35.526 20.687L24.217 31.996C24.048 32.165 23.819 32.26 23.58 32.26C23.341 32.26 23.113 32.165 22.944 31.996L16.594 25.647C16.242 25.295 16.242 24.725 16.594 24.373C16.945 24.022 17.516 24.022 17.867 24.373L23.58 30.087L34.254 19.413Z" />
  </svg>
);

export default CheckCircleIcon;
